import React, { useEffect, FC, useState } from "react";
import { connect } from "react-redux";

import { Form, Input, Select, Button, message, Cascader, Row, Col } from "antd";

import "../login/login.less";
import axios from "@/axios/axios";
import * as actions from "@/store/actions";
import http from "@/fetch/fetch";

const { Option } = Select;
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const UserInfoForm: FC<any> = ({ history, setUserInfo }) => {
  const [form] = Form.useForm();

  // 提交方法
  const onFinish = (values: any): void => {
    const {
      name,
      mobile,
      genderCode,
      idType,
      idCard,
      companyName,
      departmentName,
      verificationCode,
    } = values;
    const [provinceCode, cityCode, districtCode] = values.area;
    const professionalTitle = values.professionalTitle.join();
    const majorCode1 = values.majorCode1.join();

    saveUserInfo(
      {
        name,
        mobile,
        genderCode,
        idType,
        idCard,
        companyName,
        departmentName,
        provinceCode,
        cityCode,
        districtCode,
        professionalTitle,
        majorCode1,
      },
      verificationCode
    );
  };

  const saveUserInfo = async (params: any, urlParams: any) => {
    const url = `/user/api/continuing/saveUserBasicInfo?verificationCode=${urlParams}`;
    const { code, msg }: any = await axios.post(url, params);
    if (code === 0) {
      history.push("/index/home");
    } else {
      message.error(msg);
    }
  };

  const getUserInfo = async () => {
    const { code, data, msg }: any = await http.get(
      "/user/api/continuing/getUserInfo"
    );
    if (code === 0) {
      const { provinceCode, cityCode, districtCode } = data;
      data.area = [provinceCode, cityCode, districtCode].filter(
        (item) => !!item
      );
      data.professionalTitle = (data.professionalTitle || "")
        .split(",")
        .filter((item: any) => !!item)
        .map((item: any) => +item);
      data.majorCode1 = (data.majorCode1 || "")
        .split(",")
        .filter((item: any) => !!item)
        .map((item: any) => +item);
      form.setFieldsValue(data);
    }
  };

  // 职称数据
  const [professionalTitleList, setProfessionalTitleList] = useState([]);
  const onChangeProfessionalTitle = (value: any) => {
    console.log(value);
  };
  const getProfessionalTitle = async () => {
    const { code, data, msg }: any = await axios.get(
      "/user/api/continuing/getProfessionalTitleList"
    );
    code === 0 && setProfessionalTitleList(data);
  };

  // 单位区域数据
  const [areaList, setAreaList] = useState([]);
  const onChangeArea = (value: any) => {
    console.log(value);
  };
  const getArea = async () => {
    const { code, data, msg }: any = await axios.get(
      "/user/api/continuing/getRegionCascadeList"
    );
    code === 0 && setAreaList(data);
  };

  // 所属学科数据
  const [majorCodeList, setMajorCodeList] = useState([]);
  const onChangeMajor = (value: any) => {
    console.log(value);
  };
  const getMajor = async () => {
    const { code, data, msg }: any = await axios.get(
      "/user/api/continuing/getMajorList"
    );
    code === 0 && setMajorCodeList(data);
  };

  const smsCode = async () => {
    const mobile = form.getFieldValue("mobile");
    const url = `/user/api/continuing/sendRandomCode/${mobile}`;
    const { code, msg }: any = await axios.get(url);
    if (code !== 0) {
      message.error(msg);
    }
  };

  useEffect(() => {
    getUserInfo();
    getProfessionalTitle();
    getArea();
    getMajor();
  }, []);

  const FormView = (
    <Form
      form={form}
      {...layout}
      className="login-form"
      name="info-form"
      onFinish={onFinish}
    >
      <h2 style={{ marginBottom: "25px", textAlign: "center" }}>补充信息</h2>
      <Form.Item
        label="真实姓名"
        name="name"
        rules={[{ required: true, message: "请输入用户名" }]}
      >
        <Input placeholder="请输入" />
      </Form.Item>
      <Form.Item
        label="手机号"
        name="mobile"
        rules={[
          { required: true, message: "请输入手机号" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
            message: "请输入正确的手机号",
          },
        ]}
      >
        <Input placeholder="请输入" />
      </Form.Item>
      <Form.Item
        label="性别"
        name="genderCode"
        rules={[{ required: true, message: "请选择性别" }]}
      >
        <Select placeholder="请选择" allowClear>
          <Option value="1_Gender">男</Option>
          <Option value="2_Gender">女</Option>
        </Select>
      </Form.Item>
      <Form.Item
        label="证件类型"
        name="idType"
        rules={[{ required: true, message: "请选择证件类型" }]}
      >
        <Select placeholder="请选择" allowClear>
          <Option value={1}>身份证</Option>
          <Option value={2}>护照/港澳通行证</Option>
          <Option value={3}>军官证</Option>
        </Select>
      </Form.Item>
      <Form.Item
        label="证件号"
        name="idCard"
        rules={[
          { required: true, message: "请输入证件号" },
          {
            min: 8,
            max: 18,
            message: "请输入正确证件号",
          },
        ]}
      >
        <Input placeholder="请输入" />
      </Form.Item>
      <Form.Item
        label="职称"
        name="professionalTitle"
        rules={[{ required: true, message: "请选择职称" }]}
      >
        <Cascader
          options={professionalTitleList}
          onChange={onChangeProfessionalTitle}
          placeholder="请选择"
        />
      </Form.Item>
      <Form.Item
        label="单位区域"
        name="area"
        rules={[{ required: true, message: "请选择单位区域" }]}
      >
        <Cascader
          options={areaList}
          onChange={onChangeArea}
          placeholder="请选择"
        />
      </Form.Item>
      <Form.Item
        label="工作单位"
        name="companyName"
        rules={[
          { required: true, message: "请输入工作单位" },
          { max: 50, message: "最多50字符" },
        ]}
      >
        <Input placeholder="请输入" />
      </Form.Item>
      <Form.Item
        label="科室"
        name="departmentName"
        rules={[
          { required: true, message: "请输入科室" },
          { max: 50, message: "最多50字符" },
        ]}
      >
        <Input placeholder="请输入" />
      </Form.Item>
      <Form.Item
        label="所属学科"
        name="majorCode1"
        rules={[{ required: true, message: "请选择所属学科" }]}
      >
        <Cascader
          options={majorCodeList}
          onChange={onChangeMajor}
          placeholder="请选择"
        />
      </Form.Item>
      <Form.Item label="手机验证码">
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item
              name="verificationCode"
              noStyle
              rules={[{ required: true, message: "请输入验证码!" }]}
            >
              <Input placeholder="请输入验证码" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              onClick={() => {
                smsCode();
              }}
            >
              获取验证码
            </Button>
          </Col>
        </Row>
      </Form.Item>
      <Form.Item wrapperCol={{ span: 12, offset: 4 }}>
        <div style={{ textAlign: "center" }}>
          <Button htmlType="submit" type="primary">
            提交
          </Button>
        </div>
      </Form.Item>
      <Form.Item>
        <div style={{ textAlign: "center" }}>
          <p>客服电话: 400-001-8080</p>
        </div>
      </Form.Item>
    </Form>
  );
  return (
    <div className="login-layout" id="login-layout">
      <div className="login-box">
        <div className="logo-name">医视界 | 远程继续医学教育平台</div>
        <div className={"login-form-box"} style={{ width: "800px" }}>
          {FormView}
        </div>
      </div>
    </div>
  );
};

export default connect((state) => state, actions)(UserInfoForm);
